import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule, ScaleType, LegendPosition } from '@swimlane/ngx-charts';


@Component({
  selector: 'app-charts-two',
  standalone: true,
  imports: [CommonModule, NgxChartsModule, BrowserModule, BrowserAnimationsModule],
  templateUrl: './charts-two.component.html',
  styleUrls: ['./charts-two.component.css']
})
export class ChartsTwoComponent {
  multi: any;
  view: any = [1000, 400];

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = true;
  showLegend: boolean = false;
  legendPosition = LegendPosition.Right;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = 'Regions';
  xAxisLabel: string = 'Policy Counts per Region vs Total Premium per Region';
  showYAxisLabel: boolean = true;
  colorScheme: any = {
    domain: ['#f8051f', '#34495e', '#34495e']
  };
  schemeType: ScaleType = ScaleType.Linear;
  

  constructor() {
  }
  ngOnInit(): void {
    this.multi = [
      {
        "name": "Institutional",
        "series": [
          {
            "name": "Total Premium",
            "value": 730000
          },
          {
            "name": "Policy Count",
            "value": 12000
          }
        ]
      },

      {
        "name": "Energy & Special risks",
        "series": [
          {
            "name": "Total Premium",
            "value": 890000
          },
          {
            "name": "Policy Count",
            "value": 15000
          }
        ]
      },

      {
        "name": "Corporate 1",
        "series": [
          {
            "name": "Total Premium",
            "value": 640000
          },
          {
            "name": "Policy Count",
            "value": 8500
          }
        ]
      },
      {
        "name": "Corporate 2",
        "series": [
          {
            "name": "Total Premium",
            "value": 720000
          },
          {
            "name": "Policy Count",
            "value": 3000
          }
        ]
      },
      {
        "name": "Corporate 3",
        "series": [
          {
            "name": "Total Premium",
            "value": 890000
          },
          {
            "name": "Policy Count",
            "value": 2500
          }
        ]
      },
      {
        "name": "Lagos Region",
        "series": [
          {
            "name": "Total Premium",
            "value": 1100000
          },
          {
            "name": "Policy Count",
            "value": 61000
          }
        ]
      },
      {
        "name": "Abuja & North Central Region",
        "series": [
          {
            "name": "Total Premium",
            "value": 1100000
          },
          {
            "name": "Policy Count",
            "value": 49000
          }
        ]
      },
      // {
      //   "name": "North Region",
      //   "series": [
      //     {
      //       "name": "Total Premium",
      //       "value": 700000
      //     },
      //     {
      //       "name": "Policy Count",
      //       "value": 49
      //     }
      //   ]
      // },
      // {
      //   "name": "East Region",
      //   "series": [
      //     {
      //       "name": "Total Premium",
      //       "value": 830000
      //     },
      //     {
      //       "name": "Policy Count",
      //       "value": 49
      //     }
      //   ]
      // },
      // {
      //   "name": "South Region",
      //   "series": [
      //     {
      //       "name": "Total Premium",
      //       "value": 560000
      //     },
      //     {
      //       "name": "Policy Count",
      //       "value": 23
      //     }
      //   ]
      // },
      // {
      //   "name": "Midwest Region",
      //   "series": [
      //     {
      //       "name": "Total Premium",
      //       "value": 900000
      //     },
      //     {
      //       "name": "Policy Count",
      //       "value": 15
      //     }
      //   ]
      // },
      // {
      //   "name": "West Region",
      //   "series": [
      //     {
      //       "name": "Total Premium",
      //       "value": 600000
      //     },
      //     {
      //       "name": "Policy Count",
      //       "value": 29
      //     }
      //   ]
      // },
    ];
  }

}
